import { router } from '@/router';
import { initAuth, syncUser } from '@/utils';
import '@/utils/i18n';
import '@/utils/sentry';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

/**
 * Components
 */
import Config from './layouts/config';

/**
 * Styles
 */
import 'antd/dist/reset.css';
import './main.less';

initAuth();

await syncUser();

createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={new QueryClient()}>
        <Config>
            <RouterProvider router={router} />
        </Config>
    </QueryClientProvider>,
);
